export const FORGETME_START = 'FORGETME_START';
export const FORGETME_SUCCESS = 'FORGETME_SUCCESS';
export const FORGETME_FAILURE = 'FORGETME_FAILURE';